

import { useMemo } from "react";
import { IBigscreenSettings, ICustomMetrics } from "../constants/interfaces";
import computeCustomFields from "./computeCustomFields";

const useCustomFields = (bigscreenSettings?: Array<IBigscreenSettings>): Array<ICustomMetrics> | undefined => {
    const eventFields = useMemo(() => {
        if (!bigscreenSettings) return undefined;

        return computeCustomFields(bigscreenSettings);
    }, [bigscreenSettings])

    return eventFields;
};

export default useCustomFields;
